import React, { useState } from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { GREEN_CLOSE_BTN, FILE_CANCELED } from "../../../../../assets";
import { Paperclip } from "lucide-react";

interface RecusalRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
  onDecline: () => void;
}

const RecusalRequestModal: React.FC<RecusalRequestModalProps> = ({
  isOpen,
  onClose,
  onApprove,
  onDecline,
}) => {
  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[387px]"
      edges="rounded-2xl"
    >
      <div className="w-full px-6 py-8 flex flex-col gap-y-6 relative">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-[#98A2B3] hover:text-gray-600 transition-colors"
        >
          <img src={GREEN_CLOSE_BTN} alt="Close" className="w-5 h-5" />
        </button>

        <div className="flex flex-col items-start gap-y-3">
          <h2 className="text-[16px] font-semibold text-[#AAAAAA]">
            Recusal request
          </h2>
          <p className="text-sm leading-relaxed text-[#AAAAAA] text-start">
            Understanding the judicial consequence of the act under section 54
            of the amended constitution of the Federal Republic of Nigeria.
          </p>
        </div>

        <button
          type="button"
          className="w-full border border-[#E5E7EB] rounded-xl bg-white px-4 py-3 flex items-center gap-3 hover:bg-gray-50 transition-colors"
        >
          <div className="w-10 h-10 rounded-full bg-[#F3F4F6] flex items-center justify-center">
            <Paperclip className="w-5 h-5 text-[#6B7280] -rotate-45" />
          </div>
          <span className="text-sm font-medium text-[#009444]">
            View attachment
          </span>
        </button>

        <div className="grid grid-cols-2 gap-x-4 mt-2">
          <button
            type="button"
            onClick={onDecline}
            className="w-full bg-[#F04438] text-white rounded-lg py-3 text-sm font-medium hover:bg-[#D93025] transition-colors"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={onApprove}
            className="w-full bg-[#00B074] text-white rounded-lg py-3 text-sm font-medium hover:bg-[#009060] transition-colors"
          >
            Approve request
          </button>
        </div>
      </div>
    </ModalV2>
  );
};

interface ReasonForRefusalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title?: string;
}

export const ReasonForRefusalModal: React.FC<ReasonForRefusalModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
}) => {
  const [reason, setReason] = useState(
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  );

  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[412px]"
      edges="rounded-2xl"
    >
      <div className="w-full px-6 py-8 flex flex-col gap-y-6 relative">
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-[#98A2B3] hover:text-gray-600 transition-colors"
        >
          <img src={GREEN_CLOSE_BTN} alt="Close" className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-bold text-[#101828] text-center">
          {title || "Reason for refusal"}
        </h2>

        <textarea
          rows={5}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border border-[#E5E7EB] rounded-lg p-4 text-sm text-[#101828] placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074] resize-none"
        />

        <button
          type="button"
          className="w-full border border-[#E5E7EB] rounded-xl bg-white px-4 py-3 flex flex-col items-start gap-1 hover:bg-gray-50 transition-colors"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#F3F4F6] flex items-center justify-center">
              <Paperclip className="w-5 h-5 text-[#6B7280] -rotate-45" />
            </div>
            <span className="text-sm font-medium text-[#009444]">
              Click to attach file
            </span>
          </div>
          <span className="text-[11px] text-[#98A2B3] mt-1">
            PNG, JPG or PDF (max. 10 MB)
          </span>
        </button>

        <button
          type="button"
          onClick={onSubmit}
          className="w-full bg-[#00B074] text-white rounded-lg py-3 text-sm font-medium hover:bg-[#009060] transition-colors"
        >
          Submit
        </button>
      </div>
    </ModalV2>
  );
};

interface RecusalDeclinedSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RecusalDeclinedSuccessModal: React.FC<
  RecusalDeclinedSuccessModalProps
> = ({ isOpen, onClose }) => {
  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[480px]"
      edges="rounded-2xl"
    >
      <div className="px-12 py-10 flex flex-col w-full items-center justify-center gap-y-4">
        <img src={FILE_CANCELED} className="w-[120px] h-[120px]" alt="" />
        <span className="text-[20px] font-semibold text-[#4B5563]">
          Recusal request Declined
        </span>

        <button
          type="button"
          onClick={onClose}
          className="bg-[#00B074] w-full text-white px-10 py-3 rounded-xl text-sm font-medium hover:bg-[#009060] transition-colors"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
};

export default RecusalRequestModal;
